/* eslint-disable no-magic-numbers */
import { businessTypeOptions } from '@futrli/shared-services';

export enum METADATA_FIELD {
  BUSINESS_TYPE = 'futrlibusinesstype',
  SUBSCRIPTION_STATUS = 'futrlisubscriptionstatus'
}

enum BUSINESS_TYPE_METADATA {
  IS_ACCOUNTANT = 'accountant',
  IS_BOOKKEEPER = 'bookkeeper',
  IS_BUSINESS = 'business'
}

export const businessTypeMetaData = {
  [businessTypeOptions[0].id]: BUSINESS_TYPE_METADATA.IS_ACCOUNTANT,
  [businessTypeOptions[1].id]: BUSINESS_TYPE_METADATA.IS_BOOKKEEPER,
  [businessTypeOptions[2].id]: BUSINESS_TYPE_METADATA.IS_BUSINESS
};

export const INTERNAL_BUSINESS_TYPE = 'internal';

export const PENDO_RANDOM_ID_PREFIX = '_PENDO_T_';
